import { defineMessages } from 'react-intl'
import Validation from '../lib/validation'

export const validateCreateTranslation = (data) => {
  const validator = new Validation(data)
  validator.isRequired('name', messages.nameRequired)
  validator.isArrayWithLength('words', 1, messages.wordsMsg)
  return validator.validate()
}

export const validateCreateOpenQuestion = (data) => {
  const validator = new Validation(data)
  validator.isRequired('name', messages.nameRequired)
  validator.isArrayWithLength('openQuestions', 1, messages.questionMsg)
  return validator.validate()
}

export const validateCreateWordbox = (data) => {
  const validator = new Validation(data)
  validator.isRequired('name', messages.nameRequired)
  validator.isRequired('text', messages.textRequired)
  validator.isArrayWithLength('fillIndexes', 1, messages.fillIndexesMsg)
  return validator.validate()
}

export const validateCreateOptions = (data) => {
  const validator = new Validation(data)
  validator.isRequired('name', messages.nameRequired)
  validator.isArrayWithLength('questions', 1, messages.questionsMsg)
  return validator.validate()
}

const messages = defineMessages({
  nameRequired: {
    id: 'validations.lessons.nameRequired',
    defaultMessage: 'Názov je povinný.',
  },
  wordsMsg: {
    id: 'validations.lessons.wordsMsg',
    defaultMessage: 'Vložte aspoň jeden preklad.',
  },
  questionMsg: {
    id: 'validations.lessons.questionMsg',
    defaultMessage: 'Vložte aspoň jednu otázku.',
  },
  textRequired: {
    id: 'validations.lessons.textRequired',
    defaultMessage: 'Text je povinný.',
  },
  fillIndexesMsg: {
    id: 'validations.lessons.fillIndexesMsg',
    defaultMessage: 'Označte aspoň jedno slovo pre doplnenie.',
  },
  questionsMsg: {
    id: 'validations.lessons.questionsMsg',
    defaultMessage: 'Pridajte aspoň jednu otázku.',
  },
})



// WEBPACK FOOTER //
// ./src/common/lessons/validations.js